import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { IncompleteTyresQueryKeys } from "modules/IncompleteTyresDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { TyreID } from "models";

type ReplaceTyrePayload = {
  complete_tyre_id: TyreID;
  incomplete_tyre_id: TyreID;
};

export const useReplaceTyreMutation = () =>
  useTypedMutation<ReplaceTyrePayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/tyres/incomplete/replace", payload, ENV.carBaseURL);
    },
    onSuccess: payload => {
      const incompleteTyres = typedQueryClient.getQueryData(IncompleteTyresQueryKeys.incompleteTyres);
      if (!incompleteTyres) return;

      const index = incompleteTyres.tyres.findIndex(tyre => tyre.id === payload.incomplete_tyre_id);
      if (index === -1) return;

      typedQueryClient.setQueryData(IncompleteTyresQueryKeys.incompleteTyres, {
        ...incompleteTyres,
        tyres: incompleteTyres.tyres.toSpliced(index, 1),
        nb_items: incompleteTyres.nb_items - 1
      });
    }
  });
